import React from 'react';
const B = 'https://customer-assets-cm19k8pv.emergentagent.net/job_1373bd47-7a24-47ca-adae-0f2fe2678f07/artifacts/';
const PINKS = `${B}34c9b9658e928774_IMG_9893%202.JPG`;
const BLUES = `${B}0e47bc2cf8333941_IMG_9895%202.JPG`;

const SPECS = [
  { k: 'Material', v: 'Satin polyester', d: 'Smooth sheen with a soft hand that sews easily.' },
  { k: 'Length', v: '10 yards', d: 'On every roll, in both widths.' },
  { k: 'Widths', v: '1.5" · 5/8"', d: 'Bold statement or fine detail.' },
  { k: 'Pattern', v: 'Basket-inspired', d: 'Designed from California Native basketry.' },
  { k: 'Pattern colors', v: 'White or black', d: 'Classic white print, plus black-pattern styles.' },
  { k: 'Designed by', v: 'Finest Feathers', d: 'An Indigenous-owned California brand.' },
];

export const RibbonSpecs = () => (
  <section className="relative py-20 sm:py-28 overflow-hidden" data-testid="ribbon-specs">
    <div className="absolute left-0 top-0 w-[480px] h-[480px] rounded-full bg-[#ff6a00]/15 blur-[140px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5">
        <p className="rb-eyebrow mb-4">What's on the roll</p>
        <h2 className="rb-head text-5xl sm:text-6xl mb-10"><span className="rb-neon">Your creativity has</span> <span className="rb-grad">no limits.</span></h2>
        <div className="grid grid-cols-2 gap-3">
          <img src={PINKS} alt="Pink ribbon collection" loading="lazy" className="rounded-3xl aspect-[3/4] object-cover w-full border border-[#ff6a00]/30 shadow-[0_0_30px_rgba(255,106,0,0.25)]" />
          <img src={BLUES} alt="Blue ribbon collection" loading="lazy" className="rounded-3xl aspect-[3/4] object-cover w-full mt-10 border border-[#ff6a00]/30 shadow-[0_0_30px_rgba(255,106,0,0.25)]" />
        </div>
      </div>
      <ul className="lg:col-span-7 rb-glass rounded-3xl divide-y divide-white/10 px-6 sm:px-8">
        {SPECS.map((s) => (
          <li key={s.k} className="py-5 grid sm:grid-cols-12 gap-2 sm:gap-6 items-baseline" data-testid={`spec-${s.k.toLowerCase().replace(/\s/g, '-')}`}>
            <h3 className="sm:col-span-4 rb-head text-2xl text-white">{s.k}</h3>
            <p className="sm:col-span-3 font-bold text-[#ff9a3c] [text-shadow:0_0_10px_rgba(255,106,0,0.6)]">{s.v}</p>
            <p className="sm:col-span-5 text-white/60 text-sm">{s.d}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
